import { render, staticRenderFns } from "./MMLBackup.vue?vue&type=template&id=5d5cb445&scoped=true&"
import script from "./MMLBackup.vue?vue&type=script&lang=js&"
export * from "./MMLBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cb445",
  null
  
)

export default component.exports